import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PackageSlick = ({
	dots,
	infinite,
	speed,
	autoplay,
	autoplaySpeed,
	slidesToShow,
	slidesToScroll,
	centerMode,
	nextArrow,
	prevArrow,
	tabletSlidesToShow,
	tabletSlidesToScroll,
	mobileSlidesToShow,
	mobileSlidesToScroll,
	lang,
	main,
}) => {
	const setting = {
		dots: dots, // 슬라이드 밑에 점 보이게
		infinite: infinite, // 무한으로 반복
		speed: speed, // 넘기는 속도
		autoplay: autoplay, // 자동으로 넘김
		autoplaySpeed: autoplaySpeed, //자동으로 넘어가는 속도
		slidesToShow: slidesToShow, // 스크린에 보여지는 슬라이드 개수
		slidesToScroll: slidesToScroll, // n장씩 뒤로 넘어가게 함
		// centerMode: true,   // 중앙정렬
		// centerPadding: '0px', // 0px 하면 슬라이드 끝쪽 이미지가 안잘림
		nextArrow: <></>, // 이전 화살표
		prevArrow: <></>, // 다음 화살표
		responsive: [
			// 반응형 웹 구현 옵션
			{
				breakpoint: 1024, //화면 사이즈 960px
				settings: {
					//위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
					slidesToShow: tabletSlidesToShow,
					slidesToScroll: tabletSlidesToScroll,
				},
			},
			{
				breakpoint: 768, //화면 사이즈 768px
				settings: {
					//위에 옵션이 디폴트 , 여기에 추가하면 그걸로 변경
					slidesToShow: mobileSlidesToShow,
					slidesToScroll: mobileSlidesToScroll,
				},
			},
		],
		lang, // 한국어페이지인지 영어 페이지인지
		main, // main 페이지인지 아닌지
	};

	return (
		<Slider key={window.innerWidth} {...setting}>
			<div className="speaker_section_item">
				<div className="speaker_section_item-shadow " />
				<div className="img">
					<img src="https://image.chosun.com/alc/2026/01-jennifer.jpg" alt="" />
				</div>
				<div className="speaker_section_item_info">
					<div className="txt1">{lang === 'en' ? 'Jenny Shipley' : '제니 시플리'}</div>
					<div className="txt2">
						{lang === 'en' ? 'Former Prime Minister\nof New Zealand' : '전 뉴질랜드 총리'}
					</div>
				</div>
			</div>
			<div className="speaker_section_item">
				<div className="speaker_section_item-shadow " />
				<div className="img">
					<img src="https://image.chosun.com/alc/2026/02-akie.jpg" alt="" />
				</div>
				<div className="speaker_section_item_info">
					<div className="txt1">{lang === 'en' ? 'Akie Abe' : '아베 아키에'}</div>
					<div className="txt2">
						{lang === 'en' ? 'Chairperson\nof The FESCO   ' : '사회공헌재단 이사장'}
					</div>
				</div>
			</div>
			<div className="speaker_section_item">
				<div className="speaker_section_item-shadow " />
				<div className="img">
					<img src="https://image.chosun.com/alc/2026/03-mick.jpg" alt="" />
				</div>
				<div className="speaker_section_item_info">
					<div className="txt1">{lang === 'en' ? 'Mick Mulvaney' : '믹 멀베이니'}</div>
					<div className="txt2">
						{lang === 'en' ? 'Former White House\nChief of Staff' : '도널드 트럼프 1기 비서실장'}
					</div>
				</div>
			</div>
			<div className="speaker_section_item">
				<div className="speaker_section_item-shadow " />
				<div className="img">
					<img src="https://image.chosun.com/alc/2026/04-ohhyun.jpg" alt="" />
				</div>
				<div className="speaker_section_item_info">
					<div className="txt1">{lang === 'en' ? 'Oh Hyun Kwon' : '권오현'}</div>
					<div className="txt2">
						{lang === 'en'
							? 'Former Chairman and CEO\nof Samsung Electronics'
							: '전 삼성전자 대표이사 회장'}
					</div>
				</div>
			</div>
		</Slider>
	);
};

export default PackageSlick;
